import { useMutation } from '@tanstack/react-query'
import type { PlotImportRowInput } from '@riverpark/types'
import { confirmPlotImport, previewPlotImport } from '@/lib/plots'

export function usePlotImportPreview() {
  return useMutation({
    mutationFn: (rows: PlotImportRowInput[]) => previewPlotImport(rows),
  })
}

export function usePlotImportConfirm() {
  return useMutation({
    mutationFn: (rows: PlotImportRowInput[]) => confirmPlotImport(rows),
  })
}
